import React, { useState } from "react";
import { useNavigate, Navigate } from "react-router-dom";
import { useAuth } from "../../lib/auth";
import { Button } from "../../components/ui/button";
import { Input } from "../../components/ui/input";
import { toast } from "sonner";
import { Lock } from "lucide-react";

export default function AdminLogin() {
  const { user, login } = useAuth();
  const navigate = useNavigate();
  const [form, setForm] = useState({ email: "", password: "" });
  const [loading, setLoading] = useState(false);

  if (user) return <Navigate to="/admin" replace />;

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await login(form.email, form.password);
      toast.success("Welcome back!");
      navigate("/admin");
    } catch (e) {
      const detail = e.response?.data?.detail;
      toast.error(typeof detail === "string" ? detail : "Login failed");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-brand-navy via-[#0f2847] to-brand-navy flex items-center justify-center p-4" data-testid="admin-login">
      <div className="absolute top-0 right-0 w-[600px] h-[600px] bg-brand-pink/15 rounded-full blur-3xl" />
      <div className="absolute bottom-0 left-0 w-[500px] h-[500px] bg-brand-blue/15 rounded-full blur-3xl" />

      <div className="relative w-full max-w-md">
        <form onSubmit={submit} className="bg-white rounded-2xl p-8 shadow-2xl">
          <div className="text-center mb-8">
            <img
              src="https://img1.wsimg.com/isteam/ip/6251f5ed-3ec2-463f-9bc9-248d796842b9/Untitled%20design%20(2)-01%20(1).png/:/rs=w:200,h:200,cg:true,m"
              alt="Pool Guru logo"
              className="w-20 h-20 object-contain mx-auto mb-4"
            />
            <h1 className="text-2xl font-extrabold text-brand-navy">Admin Login</h1>
            <p className="text-sm text-slate-500 mt-2">Pool Guru CMS Dashboard</p>
          </div>
          <div className="space-y-4">
            <div>
              <label className="block text-sm font-semibold text-slate-700 mb-1.5">Email</label>
              <Input
                type="email"
                value={form.email}
                onChange={(e) => setForm({ ...form, email: e.target.value })}
                required
                data-testid="login-email"
              />
            </div>
            <div>
              <label className="block text-sm font-semibold text-slate-700 mb-1.5">Password</label>
              <Input
                type="password"
                value={form.password}
                onChange={(e) => setForm({ ...form, password: e.target.value })}
                required
                data-testid="login-password"
              />
            </div>
            <Button type="submit" disabled={loading} className="w-full bg-brand-pink hover:bg-brand-pink-hover h-12" data-testid="login-submit">
              {loading ? "Signing in..." : "Sign In"}
            </Button>
          </div>
        </form>
      </div>
    </div>
  );
}
